module.exports = __webpack_public_path__ + "static/media/searching-page-herobg.94433380.jpg";